const STORAGE_KEY = 'soundEnabled'

let soundEnabled =
  localStorage.getItem(STORAGE_KEY) !== 'false' // default true

export const setGlobalSoundEnabled = (enabled: boolean) => {
  soundEnabled = enabled
  localStorage.setItem(STORAGE_KEY, String(enabled))
}

export const getGlobalSoundEnabled = () => soundEnabled